import React, { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Radio from '@mui/material/Radio';
import ClearIcon from '@mui/icons-material/Clear';


export default function YearWeekSelect({
  data,
  label_select,
  selectedData,
  setSelectedData,
  clearable,
}: any): any {
  const [selected, setSelected] = useState(selectedData);

  useEffect(() => {
    setSelected(selectedData);
  }, [selected, selectedData, data, setSelectedData]);

  const handleSelect = (value: any): void => {
    if (label_select === 'Revenue Type') {
      setSelected(value.value);
      setSelectedData(value.value);
    } else {
      setSelected(value.value);
      setSelectedData(value.value);
    }
  };

  return (
    <>
      <Autocomplete
        id="checkboxes-tags-demo"
        options={data}
        size="small"
        value={{ value: selected, label: selected.toString() }}
        getOptionLabel={(option: any) => option.label}
        renderOption={(props, option) => (
          <li {...props}>
            <Radio checked={option.value == selected} />
            {option.label}
          </li>
        )}
        isOptionEqualToValue={(option: any, value: any) => {
          return option.value === value.value;
        }}
       sx={{ width: '48%' }}
        renderInput={(params) => (
          <TextField
            {...params}
            required
            className="comboBox red-asterik"
            label={ label_select }
            variant="outlined"
            sx={{
              '& .MuiAutocomplete-input': {
                textOverflow: 'initial',
              },
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: 'blue',
              },
            }}
          />
        )}
        onChange={(event, value) => handleSelect(value)}
        clearIcon={clearable ? <ClearIcon /> : null}
      />
    </>
  );
}
